import styled from 'styled-components'

const TermsOfServiceStyles = styled.div`
  font-size: 14px;

  ${props => props.theme.media.lg} {
    font-size: 16px;
  }
`

export default TermsOfServiceStyles
